import { render, staticRenderFns } from "./company-list.vue?vue&type=template&id=b28a3706&scoped=true&"
import script from "./company-list.vue?vue&type=script&lang=js&"
export * from "./company-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28a3706",
  null
  
)

export default component.exports